import {Component, OnInit, Inject} from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { RemnantsService } from './remnants.service';
import { NotifyService } from '../shared/services/notify.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MaterialsService } from '../materials/materials.service';
import { InventoryService } from '../inventory/inventory.service';
import {Observable} from 'rxjs/Observable';
import { DOCUMENT } from "@angular/platform-browser";

@Component({
  selector: 'app-remnants',
  templateUrl: './remnants.component.html',
  styleUrls: ['./remnants.component.css']
})
export class RemnantsComponent implements OnInit {

  inventory:any[] = [];
  sForm:FormGroup;
  perPage:number = 50;
  numPages:number = 0;
  currPage:number = 1;
  pages:number[] = [];
  searchList:string[] = [];
  materials:any[] = [];
  colors:any[] = [];
  finishes:string[] = [];
  thicknesses: any[] = [];
  showAdvanced:boolean = false;
  fullCount:number = 0;
  partialCount:number = 0;

  private orderField = 'barcode';
  private orderDir = -1;

  constructor(
    @Inject(FormBuilder) fb: FormBuilder,
    @Inject(DOCUMENT) private document:any,
    private _appService: AppService,
    private _remnantsService: RemnantsService,
    private _notifyService: NotifyService,
    private _matService: MaterialsService,
    private _invService: InventoryService
  ) {
    this.sForm = fb.group({
      term: [null],
      material: [null],
      color: [null],
      finish: [null],
      minL: [null],
      maxL: [null],
      minW: [null],
      maxW: [null],
      thickness: [null]
    });
  }

  ngOnInit() {

    this.finishes = this._invService.getFinishes();
    this.searchList = this.finishes.slice(0);

    this.thicknesses = this._invService.getThicks();

    this._matService.getMaterials().subscribe(
      data => {
        this.materials = data.materials;
        this.materials.forEach( (m) => {
          this.searchList.push(m.name);
          m.colors.forEach( (c) => {
            this.searchList.push(c.name);
          })
        });
      }
    );

    this.getRemnants();

  }


  private getRemnants() {
    const params = this.sForm.value;
    params.orderField = this.orderField;
    params.orderDir = this.orderDir;
    this._appService.showLoader();
    this._remnantsService.getInventory(params).subscribe(
      data => {
        this.inventory = data.inventory;
        let f = 0;
        let p = 0;
        this.inventory.forEach(function (i) {
          if(i.slabType == 'Full') f++;
          if(i.slabType == 'Partial') p++;
        });
        this.fullCount = f;
        this.partialCount = p;
        this.numPages = Math.ceil(this.inventory.length / this.perPage);
        for(let page = 1; page <= this.numPages; page++) {
          this.pages.push(page);
        }
        setTimeout(()=>{
          this._appService.hideLoader();
        }, 500);
      }
    );
  }

  typeO = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.searchList.filter(sup => new RegExp(term, 'gi').test(sup)).splice(0, 10));

  setColors() {
    const mat = this.sForm.get('material').value;
    for(let i = 0; i< this.materials.length; i++) {
      if(this.materials[i].name == mat) {
        this.colors = this.materials[i].colors.sort((a,b)=>{
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        });
        //this.sForm.get('color').setValue(this.colors[0].name);
      }
    }
  }

  setSortCol(col){
    if(this.orderField == col) {
      this.orderDir = this.orderDir*-1;
    } else {
      this.orderDir = 1;
    }
    this.orderField = col;
    this.getRemnants();
  }

  toggleAdvanced() {
    this.showAdvanced = (this.showAdvanced)?false:true;
    if(this.showAdvanced) {
      this.sForm.get('term').setValue(null);
    }
  }

  clear() {
    this.sForm.reset();
  }

  search() {
    this.getRemnants();
  }

  nextPage() {
    if(this.currPage < this.numPages) {
      this.currPage++;
    } else {
      this.currPage = 1;
    }
    this.document.getElementById("scrollBody").scrollTop = 0;
  }

  prevPage() {
    if(this.currPage > 1) {
      this.currPage--;
    } else {
      this.currPage = this.numPages;
    }
    this.document.getElementById("scrollBody").scrollTop = 0;
  }

  setPage(event:any) {
    const p = this.pages[event.target.selectedIndex];
    if(p != this.currPage) {
      this.currPage = p;
    }
    this.document.getElementById("scrollBody").scrollTop = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/remnants/remnants.component.ts